import { createAPI } from '@common'
export default {
  // 云雀-单点登录到第三方
  getMediaxEntryCgiValidate: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0ttp0difdlTvn', 'GET', config),
  getSysAutologinCheckSum: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0f60bvupmphjo0difdltvn', 'GET', config),
  getSysAutologin: (config) => createAPI('customEncryptApiName-1/0nfejby.tztufn0nbjo0bvupmphjo', 'POST', config)
}
